import { scan, shareReplay, startWith } from 'rxjs/operators';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';

import { Injectable, OnDestroy, TemplateRef } from '@angular/core';

@Injectable()
export class SelectService<T = any> implements OnDestroy {
  readonly beforeOpened$ = new ReplaySubject<void>(1);

  readonly afterOpened$ = new ReplaySubject<void>(1);

  readonly optionSelected$ = new Subject<{ isNew: boolean; value: T | null }>();

  readonly radioSelected$ = new BehaviorSubject<boolean>(void 0);

  readonly defaultSelection$ = new BehaviorSubject<T | undefined>(void 0);

  readonly isMultiSelect$ = new BehaviorSubject<boolean>(false);

  readonly confirm$ = new BehaviorSubject<boolean>(false);

  readonly minSelected$ = new BehaviorSubject<number>(null);

  readonly value$ = new BehaviorSubject<T | undefined>(void 0);

  readonly search$ = new BehaviorSubject<string>('');

  selectLabel?: TemplateRef<T>;

  selectLabelPrefix?: TemplateRef<T>;

  private readonly updateOptionLabels$ = new Subject<{ value; template }>();

  readonly optionLabelPrefixes = new Map<T, TemplateRef<T>>();

  private optionLabels = new Map<T, TemplateRef<T>>();

  readonly optionLabels$ = this.updateOptionLabels$.pipe(
    scan((a, { value, template }) => a.set(value, template), this.optionLabels),
    startWith(this.optionLabels),
    shareReplay({ refCount: true, bufferSize: 1 }),
  );

  updateOptionLabels(value: T, template?: TemplateRef<T>): void {
    this.optionLabels.set(value, template);
    this.updateOptionLabels$.next({ value, template });
  }

  ngOnDestroy(): void {
    this.value$.complete();
    this.updateOptionLabels$.complete();
    this.afterOpened$.complete();
    this.beforeOpened$.complete();
    this.optionSelected$.complete();
    this.radioSelected$.complete();
    this.defaultSelection$.complete();
    this.isMultiSelect$.complete();
  }
}
